import * as api from "@/api/environmental/index";
import { EnvironmentalResponseDTO, EnvironmentalDTO } from "@/api/environmental/types";

export async function create(analysisUuid: string, years: number[]): Promise<EnvironmentalResponseDTO[]> {
  return (await api.create(analysisUuid, years)).data;
}


export async function find(analysisUuid: string, year: number): Promise<EnvironmentalDTO> {
  try {
    return (await api.find(analysisUuid, year)).data;
  } catch {
    return new EnvironmentalDTO();
  }
}


export async function downloadGeoJson(url: string): Promise<GeoJSON.FeatureCollection> {
  return await api.downloadGeoJson(url);
}


export async function downloadImage(url: string) {
  return await api.downloadImage(url);
}